/*
 * PathwayDSavePrompt — in-editor save-time guard (Cluster 5 Slice 2 / A8 pt 6).
 * Patterned on RunWorkflowDialog (open / onClose overlay+dialog).
 *
 * Fires (from WorkflowDesigner.handleSave) when pathway_d_enabled is off and the
 * workflow has no match-capable extraction path (see pathwayDPrompt.js / R4).
 * NOT a blocker — "Save as-is" proceeds with the save unchanged.
 *
 * Variants (canEdit = builder: admin||power_user — R-panel 2026-06-14):
 *  - Builder: "Save as-is" + "Enable Claude AI fallback" (flips the flag true then
 *    saves, via WorkflowDesigner's doSave({ pathway_d_enabled: true })).
 *  - Non-builder: informational only — a single "Save as-is" acknowledgement, NO
 *    enable button. (In practice the designer route is builder-guarded, so a plain
 *    member never reaches this prompt; the canEdit guard is defensive.)
 */

import React from 'react';
import './PathwayDSavePrompt.css';

const PathwayDSavePrompt = ({ open, canEdit, onClose, onSaveAsIs, onEnableFallback }) => {
  if (!open) return null;

  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="pdp-overlay" onClick={handleOverlay}>
      <div className="pdp-dialog" role="dialog" aria-modal="true">
        <div className="pdp-header">
          <span className="pdp-icon">⚠️</span>
          <h3 className="pdp-title">No fallback for unmatched documents</h3>
        </div>

        <p className="pdp-body">
          This workflow has no vendor profile lookup and no template match step. With Claude
          AI fallback disabled, documents matching no vendor or template will be routed to
          human review.{canEdit ? ' Continue, or enable Claude AI fallback?' : ''}
        </p>

        <div className="pdp-actions">
          <button className="pdp-btn pdp-btn-secondary" onClick={onSaveAsIs}>
            Save as-is
          </button>
          {canEdit && (
            <button className="pdp-btn pdp-btn-primary" onClick={onEnableFallback}>
              Enable Claude AI fallback
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PathwayDSavePrompt;
